/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconQuoteLeft from '@telus-uds/palette-public-mobile/build/rn/icons/QuoteLeft'
import PaletteIconQuoteLeftArrow from '@telus-uds/palette-public-mobile/build/rn/icons/QuoteLeftArrow'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    additionalFontName: 'SofiaPro',
    additionalFontSize: 14,
    additionalFontWeight: '400',
    additionalLineHeight: 1.4285714285714286,
    authorFontName: 'SofiaPro',
    authorFontSize: 18,
    authorFontWeight: '700',
    authorLineHeight: 1.55555555,
    dividerBackgroundColor: '#9c9faa',
    dividerBorder: 1,
    figcaptionGap: 12,
    icon: PaletteIconQuoteLeft,
    iconColor: '#9c9faa',
    iconFr: PaletteIconQuoteLeftArrow,
    imageSize: 48,
    quoteContainerGap: 4,
    testimonialContainerGap: 12,
    testimonialFontNameHeading: 'SofiaPro',
    testimonialFontNameLarge: 'SofiaPro',
    testimonialFontSizeHeading: 30,
    testimonialFontSizeLarge: 20,
    testimonialFontWeightHeading: '700',
    testimonialFontWeightLarge: '400',
    testimonialLineHeightHeading: 1.2,
    testimonialLineHeightLarge: 1.4,
    textColor: '#394056'
  }
}
export default theme
